var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BowContentListMedia',{attrs:{"type":"sx","contentList":_vm.contentList,"cta":_vm.cta,"htmlTag":_vm.htmlTag,"media":_vm.media,"text":_vm.text,"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }